var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSamparkKkPendingBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C3D2DF",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M18.068 4.62l.015.008C19.277 5.318 20 6.533 20 7.881v6.272a3.685 3.685 0 0 1-1.932 3.228l-5.677 3.141a3.987 3.987 0 0 1-3.792-.005l-5.657-3.131A3.65 3.65 0 0 1 1 14.153V7.847c0-1.336.745-2.588 1.932-3.228L8.61 1.478a3.987 3.987 0 0 1 3.792.005l5.667 3.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.5 15.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm-.41-4.5H8.865a.41.41 0 0 0 0 .818H10.5a.41.41 0 0 0 .41-.409V8.955a.41.41 0 0 0-.82 0V11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSamparkKkPendingBadge);
export default __webpack_public_path__ + "static/media/icon_sampark_kk_pending_badge.99d41f6fb8415aced1a59eac3c2511e3.svg";
export { ForwardRef as ReactComponent };